import React from 'react';
import { Link } from 'react-router-dom';

const HeroCarousel = () => {
  return (
    <div className="carousel-header">
      <div id="carouselId" className="carousel slide" data-bs-ride="carousel">
        <ol className="carousel-indicators">
          <li data-bs-target="#carouselId" data-bs-slide-to="0" className="active"></li>
          <li data-bs-target="#carouselId" data-bs-slide-to="1"></li>
          <li data-bs-target="#carouselId" data-bs-slide-to="2"></li>
        </ol>
        <div className="carousel-inner" role="listbox">
          <div className="carousel-item active">
            <img src="/assets/img/carousel-1.png" className="img-fluid" alt="Image" />
            <div className="carousel-caption">
              <div className="text-center p-4" style={{ maxWidth: '900px' }}>
                <h4 className="text-white text-uppercase fw-bold mb-3 mb-md-4 wow fadeInUp" data-wow-delay="0.1s">
                  Solution For All Type Of Visas of Canada
                </h4>
                <h1 className="display-1 text-capitalize text-white mb-3 mb-md-4 wow fadeInUp" data-wow-delay="0.3s">
                  Immigration Process Starts Here!
                </h1>
                <p className="text-white mb-4 mb-md-5 fs-5 wow fadeInUp" data-wow-delay="0.5s">
                  Professional immigration services to help you achieve your dreams of living and working abroad.
                </p>
                <Link className="btn btn-primary border-secondary rounded-pill text-white py-3 px-5 wow fadeInUp" data-wow-delay="0.7s" to="/immigration">
                  More Details
                </Link>
              </div>
            </div>
          </div>
          <div className="carousel-item">
            <img src="/assets/img/carousel-2.png" className="img-fluid" alt="Image" />
            <div className="carousel-caption">
              <div className="text-center p-4" style={{ maxWidth: '900px' }}>
                <h5 className="text-white text-uppercase fw-bold mb-3 mb-md-4 wow fadeInUp" data-wow-delay="0.1s">
                  Business Setup Services in Canada
                </h5>
                <h1 className="display-1 text-capitalize text-white mb-3 mb-md-4 wow fadeInUp" data-wow-delay="0.3s">
                  Simplify Your Business Setup in Canada
                </h1>
                <p className="text-white mb-4 mb-md-5 fs-5 wow fadeInUp" data-wow-delay="0.5s">
                  From registration to digital presence—we guide you through every step of starting or acquiring a business.
                </p>
                <Link className="btn btn-primary border-secondary rounded-pill text-white py-3 px-5 wow fadeInUp" data-wow-delay="0.7s" to="/business-setup">
                  More Details
                </Link>
              </div>
            </div>
          </div>
          <div className="carousel-item">
            <img src="/assets/img/carousel-3.png" className="img-fluid" alt="Image" />
            <div className="carousel-caption">
              <div className="text-center p-4" style={{ maxWidth: '900px' }}>
                <h4 className="text-white text-uppercase fw-bold mb-3 mb-md-4 wow fadeInUp" data-wow-delay="0.1s">
                 Business Support Services in Canada
                </h4>
                <h1 className="display-1 text-capitalize text-white mb-3 mb-md-4 wow fadeInUp" data-wow-delay="0.3s">
                  Grow and Streamline Your Business
                </h1>
                <p className="text-white mb-4 mb-md-5 fs-5 wow fadeInUp" data-wow-delay="0.5s">
                  We provide expert support for accounting, staffing, expansion, and digital tools—empowering your business to scale efficiently.
                </p>
                <Link className="btn btn-primary border-secondary rounded-pill text-white py-3 px-5 wow fadeInUp" data-wow-delay="0.7s" to="/business-support">
                  Get Started
                </Link>
              </div>
            </div>
          </div>
        </div>
        <button className="carousel-control-prev" type="button" data-bs-target="#carouselId" data-bs-slide="prev">
          <span className="carousel-control-prev-icon bg-secondary wow fadeInLeft" data-wow-delay="0.2s" aria-hidden="false"></span>
          <span className="visually-hidden-focusable">Previous</span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#carouselId" data-bs-slide="next">
          <span className="carousel-control-next-icon bg-secondary wow fadeInRight" data-wow-delay="0.2s" aria-hidden="false"></span>
          <span className="visually-hidden-focusable">Next</span>
        </button>
      </div>
    </div>
  );
};

export default HeroCarousel; 